import { Link } from "react-router-dom";
import type { DsLinkProps } from "@constructorfleet/ui/design-system";

export function RouterDsLink({ href, children, ...rest }: DsLinkProps) {
  return (
    <Link to={href} {...rest}>
      {children}
    </Link>
  );
}
